import { useMemo } from 'react';
import { ImportTelepac } from 'services/API/Exploitation';
import ImportModalWithGroundType from './ImportModalWithGroundType';

const ImportModalTelepac = (props) => {
  const config = useMemo(() => ({
    accept: 'text/xml',
    titleKey: 'title.telepacParcelImport',
    loadingKey: 'IMPORT_TELEPAC_LOADING',
    errorKey: 'ERR_IMPORT_TELEPAC',
    apiCall: ImportTelepac,
  }), []);

  return <ImportModalWithGroundType config={config} {...props} />;
};

export default ImportModalTelepac;
